import React, { useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { loopback } from "elentari";
import { treinoApi } from "../../../services/Api";
import classNames from "classnames";
import { getColor } from "./lib";

const { loopbackFilters } = loopback;

const styles = (theme) => ({
  treinosPickerRoot: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing.unit * 2,
  },
  treinoItem: {
    borderRadius: 4,
    padding: theme.spacing.unit,
    color: "white",
  },
});

const TreinoItem = ({ classes, treino }) => (
  <Grid
    data-event={JSON.stringify({
      treinoId: treino.id,
      title: treino.nome,
      backgroundColor: treino.color,
      borderColor: treino.color,
      create: false,
    })}
    item
    className="item-draggable"
  >
    <div
      className={classNames(classes.treinoItem)}
      style={{ backgroundColor: treino.color }}
    >
      <Typography variant="caption" color="inherit">
        {treino.nome}
      </Typography>
    </div>
  </Grid>
);

const TreinoPicker = ({ classes }) => {
  const [treinos, setTreinos] = useState([]);

  const fetchTreinos = async (event) => {
    let search = "";
    if (event) {
      search = event.target.value;
    }
    const response = await treinoApi.getList({
      where: {
        nome: loopbackFilters.regexp(search),
      },
      order: "nome asc",
      limit: 14,
    });
    if (response.ok) {
      setTreinos(
        response.data.map((t) => ({
          ...t,
          color: getColor(t),
        }))
      );
    }
  };

  useEffect(() => {
    fetchTreinos();
  }, []);

  return (
    <div id="list" className={classes.treinosPickerRoot}>
      <TextField label="Buscar Treinos" onChange={fetchTreinos} fullWidth />
      <div style={{ height: 24, width: "100%" }}></div>
      <Grid container direction="column" spacing={8}>
        {treinos.map((treino) => (
          <TreinoItem classes={classes} key={treino.id} treino={treino} />
        ))}
      </Grid>
    </div>
  );
};

export default withStyles(styles)(TreinoPicker);
